export type PaymentProvider = "paystack" | "pocket" | "stripe";
export type PaymentOption = "transfer" | "card" | "bank" | "ussd" | "pocket_app";

export const DEFAULT_PAYMENT_OPTIONS: PaymentOption[] = [
  "bank",
  "transfer",
  "card",
  "ussd",
  "pocket_app",
];

export function isStripeCountry(countryCode?: string | null) {
  const normalizedCountryCode = countryCode?.toUpperCase();
  return ["US", "GB", "UK"].includes(normalizedCountryCode || "");
}

export function getPaymentOptionsForCountry(countryCode?: string | null): PaymentOption[] {
  return isStripeCountry(countryCode) ? ["card"] : DEFAULT_PAYMENT_OPTIONS;
}

export function getPaymentOptionConfig(
  option: PaymentOption,
  countryCode?: string | null,
): { provider: PaymentProvider; channels?: string[] } {
  switch (option) {
    case "card":
      return isStripeCountry(countryCode)
        ? { provider: "stripe" }
        : { provider: "paystack", channels: ["card"] };
    case "bank":
      return { provider: "paystack", channels: ["bank_transfer"] };
    case "ussd":
      return { provider: "paystack", channels: ["ussd"] };
    case "transfer":
    case "pocket_app":
      return { provider: "pocket" };
  }
}
